var map = {
	"./labmemtest_text_btn01_en.png": "35a6",
	"./labmemtest_text_btn01_jp.png": "e130",
	"./labmemtest_text_btn01_kr.png": "f2a4",
	"./labmemtest_text_btn01_sc.png": "c8c5",
	"./labmemtest_text_btn01_tc.png": "a9f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c8a9";